import { j as r } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as n } from "react";
import { B as s } from "./BaseButton-B2fMKlSI.mjs";
import "./ArrowButton-C0WywcBN.mjs";
import "./BaseLinkButton-CquLmqew.mjs";
const a = n((t, o) => /* @__PURE__ */ r.jsx(s, { buttonType: "rds-button", buttonStyle: "primary", ref: o, ...t }));
a.displayName = "PrimaryButton";
const e = n((t, o) => /* @__PURE__ */ r.jsx(s, { buttonType: "rds-button", buttonStyle: "secondary", ref: o, ...t }));
e.displayName = "SecondaryButton";
const u = n((t, o) => /* @__PURE__ */ r.jsx(s, { buttonType: "rds-button", buttonStyle: "tertiary", ref: o, ...t }));
u.displayName = "TertiaryButton";
const y = n((t, o) => /* @__PURE__ */ r.jsx(s, { buttonType: "rds-button", buttonStyle: "ghost", ref: o, ...t }));
y.displayName = "GhostButton";
export {
  y as G,
  a as P,
  e as S,
  u as T
};
